import { IconButton } from "@material-ui/core";
import styled from "styled-components";

const primary = (props) => props.theme.palette.primary;

export const IconButtonStyled = styled(IconButton)`
  background-color: ${primary} !important;
  color: white !important;

  :hover {
    background-color: orange !important;
  }

  &.Mui-disabled {
    background-color: #eeeeee !important;
  }

  .MuiSvgIcon-root {
    font-size: 1.3rem;
  }
`;
